import RewardsCarousel from './RewardsCarousel.f';

export default RewardsCarousel;
